// Autogenerated file
export const organizationActivityPeriodTypesEnum = {
    Months: "Months",
    Quarters: "Quarters",
    Years: "Years",
};
export const organizationActivityPeriodTypes = [
    { label: "По месяцам", value: "Months" },
    { label: "По кварталам", value: "Quarters" },
    { label: "По годам", value: "Years" },
];
